
















import { Vue, Component, Inject, Prop } from "vue-property-decorator";

// Types
import {
  IProvisionCategoriesProviderData,
  IProvisionCategoriesProviderMethods
} from "@/models/providers/provisioning";

@Component
export default class CreateProvisionConfiguration extends Vue {
  // Inject

  @Inject({ from: "provisionCategoriesProvider" })
  public readonly $provisionCategoriesData!: () => IProvisionCategoriesProviderData;

  public get categoriesData() {
    return this.$provisionCategoriesData();
  }

  @Inject({ from: "provisionCategoriesMethods" })
  public readonly $provisionCategoriesMethods!: IProvisionCategoriesProviderMethods;

  // Props

  @Prop({ default: "_.add_provision_configuration" })
  public titlePath!: string;

  // Methods

  public getProviderLogoUrl(provider) {
    return provider.logo_url;
  }
}
